export default __webpack_public_path__ + "static/media/hp.3dd32c2e.png";